import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { NotificationModalServiceService } from '../shared/services/notification-modal-service.service';
import { Store } from '@ngxs/store';
import {
  TicketingCartSelectors,
  TicketingGuardActions,
} from './ticketing-cart.state';
import { map, switchMap } from 'rxjs';

export const ticketingEventGuard: CanActivateFn = (route, _) => {
  const notificationModalServiceService = inject(
    NotificationModalServiceService
  );
  const router = inject(Router);
  const store = inject(Store);
  if (!route.paramMap.has('eventCode')) {
    notificationModalServiceService.showMessage({
      title: 'Missing Event',
      message: 'Please select an event',
    });
    return router.createUrlTree(['/ticketing']);
  }
  if (!route.paramMap.has('dateTime')) {
    notificationModalServiceService.showMessage({
      title: 'Missing Showtime',
      message: 'Please select a showtime',
    });
    return router.createUrlTree([
      '/ticketing',
      route.paramMap.get('eventCode'),
    ]);
  }
  return store
    .dispatch(
      new TicketingGuardActions.SetEventCodeAndDateTime({
        eventCode: route.paramMap.get('eventCode')!,
        eventDateTime: route.paramMap.get('dateTime')!,
      })
    )
    .pipe(
      switchMap(() => store.select(TicketingCartSelectors.getEventItemModel)),
      // Need to handle if somehow user navigates to not bookable event
      map((event) => {
        switch (event?.eventStatusCode) {
          case 'CO':
            notificationModalServiceService.showMessage({
              title: 'Call for Tickets',
              message: 'Limited tickets available.  Please call to book.',
            });
            return router.createUrlTree(['/ticketing']);
          case 'PS':
            notificationModalServiceService.showMessage({
              title: 'Past Show',
              message:
                'This show has already occurred.  Please select another show.',
            });
            return router.createUrlTree(['/ticketing']);
          case 'SO':
            notificationModalServiceService.showMessage({
              title: 'Sold Out',
              message: 'This show is sold out. Please select another show.',
            });
            return router.createUrlTree(['/ticketing']);
          case 'NA':
            notificationModalServiceService.showMessage({
              title: 'Not Available',
              message:
                'This show is not available. Please select another show.',
            });
            return router.createUrlTree(['/ticketing']);
          default:
            return true;
        }
      })
    );
};
